<template>
  <advanced-table
    :headers="headers"
    :filters="filters"
    :sortBy="'callFirst'"
    :descending="true"
    :resource="resource"
    :optionLists="optionLists"
  />
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";
import { format } from "date-fns";

export default {
  data() {
    return {
      headers: [
        {
          text: "שם",
          value: "name",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key] || 'ללא שם';
          },
          linkTo: item => {
            return `/translators/${item._id}`;
          }
        },
        {
          text: "תאריך יצירה",
          value: "created",
          align: "right",
          visible: false,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY");
          }
        },
        {
          text: "שפות",
          value: "languages",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            let field = "title";
            let array = data[key];
            if (Array.isArray(array) && array.length) {
              return array
                .map(item => {
                  let language = this.entityById("languages", item);
                  return language ? language[field] : 'ללא שם';
                })
                .reduce((p, v) => p + ", " + v);
            }
            return "";
          }
        },
        {
          text: "תאריך אימות פרטים",
          value: "lastValidation",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return format(data[key], "DD-MM-YYYY");
          }
        },
        {
          text: "מומלץ",
          value: "recommended",
          align: "right",
          visible: true,
          type: 'ICON',
          displayFunc: (data, key) => {
            return data[key] ? { icon: 'star', color: 'orange' } : { icon: 'mdi-star-outline', color: 'gray' };
          }
        },
        {
          text: "להתקשר ראשון",
          value: "callFirst",
          align: "right",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? "כן" : "לא";
          }
        }
      ],
      filters: [
        {
          type: "COMBOBOX",
          label: "שפות",
          model: "languages",
          items: "languages",
          itemText: "title",
          itemValue: "_id",
          active: true
        },
        {
          type: "DATE",
          label: "נוצר אחרי",
          model: "createdAfter",
          active: false
        },
        {
          type: "DATE",
          label: "נוצר לפני",
          model: "createdBefore",
          active: false
        },
        {
          type: "DATE",
          label: "אימות פרטים לפני",
          model: "lastValidationBefore",
          active: false
        },
        {
          type: "TEXT",
          label: "חיפוש חופשי",
          model: "search",
          icon: "search",
          expanded: true,
          active: true
        }
      ]
    };
  },
  computed: {
    translators() {
      return this.$store.getters["entityList"]("translators");
    },
    languages() {
      return this.$store.getters["entityList"]("languages");
    },
    resource() {
      return this.$store.state.resources["translator"];
    },
    optionLists() {
      return {
        languages: this.languages
      }
    }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    }
  },
  components: {
    AdvancedTable
  }
};
</script>



// WEBPACK FOOTER //
// src/components/translators/Translators.vue